import { FilePdfOutlined, PictureOutlined } from '@ant-design/icons';
import { Button, Form, Space, Tag, Upload } from 'antd';

/** O id só existe depois de salvar; os caminhos dos arquivos dependem dele. */
export function EnvioDeArquivo({
  tipo,
  salvo,
  temArquivo,
  enviando,
  desabilitado,
  onEnviar,
  dica,
}: {
  tipo: 'capa' | 'pdf';
  salvo: boolean;
  temArquivo: boolean;
  enviando: boolean;
  desabilitado: boolean;
  onEnviar: (arquivo: File) => void;
  /** O que dizer do arquivo quando o padrão não serve (limite ou conferência diferentes). */
  dica?: string;
}) {
  const ehCapa = tipo === 'capa';
  return (
    <Form.Item
      label={ehCapa ? 'Capa' : 'PDF'}
      extra={
        !salvo
          ? 'Disponível depois de salvar pela primeira vez.'
          : dica ?? (ehCapa
            ? 'JPEG, PNG ou WebP, até 5 MB. O envio substitui a capa anterior.'
            : 'PDF, até 20 MB. O envio substitui o arquivo anterior.')
      }
    >
      <Space wrap>
        <Upload
          accept={ehCapa ? 'image/jpeg,image/png,image/webp' : 'application/pdf'}
          showUploadList={false}
          disabled={!salvo || desabilitado}
          beforeUpload={(arquivo) => {
            onEnviar(arquivo);
            return false;
          }}
        >
          <Button
            icon={ehCapa ? <PictureOutlined /> : <FilePdfOutlined />}
            disabled={!salvo || desabilitado}
            loading={enviando}
          >
            {temArquivo ? 'Trocar' : 'Enviar'} {ehCapa ? 'capa' : 'PDF'}
          </Button>
        </Upload>
        {temArquivo && <Tag color="success">{ehCapa ? 'Capa enviada' : 'PDF enviado'}</Tag>}
      </Space>
    </Form.Item>
  );
}
